import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import H5 from '@base/H5/H5';
import { Spacings, Fonts } from '@styles/index';
import Lock from '@icon/Lock';
import CheckBig from '@icon/CheckBig';
import useMaxAttemptQuestions from '../Common/useMaxAttemptQuestions';

const Wrapper = styled.div`
  z-index: 1;
  top: 0px;
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--color-base-1);
  padding: ${Spacings.SPACING_3B} 0px;
`;

const SectionInfoLeft = styled.div`
  width: 70%;
`;

const SectionInfoRight = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  width: 30%;
`;

const SectionInfoItem = styled.div`
  margin-left: ${Spacings.SPACING_1B};
  font-size: ${Fonts.SMALL};
  font-weight: ${Fonts.SEMIBOLD};
  color: var(--color-text-primary);
`;

const SectionMaxAttemptInfo = styled.div`
  font-size: ${Fonts.SMALL};
  margin-top: ${Spacings.SPACING_2B};
  color: var(--color-text-primary);
`;

const QuestionsInfo = ({
  title,
  sectionUID,
  isLocked,
  isCompleted,
  hasOngoingSectional
}) => {
  const {
    isMaxQuestionAttemptEnabled,
    totalQuestionAnswered,
    maxAnswerableQuestion
  } = useMaxAttemptQuestions(sectionUID);

  const getAttemptInfo = () => {
    if (isMaxQuestionAttemptEnabled) {
      return `Attempt any ${maxAnswerableQuestion}`;
    }

    return 'Attempt all';
  };

  const getSectionIcons = () => {
    if (isCompleted) {
      return (
        <CheckBig size={Spacings.SPACING_4B} color="var(--color-i-green)" />
      );
    }

    if (isLocked) {
      return <Lock size={Spacings.SPACING_5B} />;
    }

    return null;
  };

  return (
    <Wrapper>
      <SectionInfoLeft>
        <H5 lineClamp={1}>{title}</H5>
        <SectionMaxAttemptInfo>{getAttemptInfo()}</SectionMaxAttemptInfo>
      </SectionInfoLeft>
      <SectionInfoRight>
        {isMaxQuestionAttemptEnabled && (
          <SectionInfoItem>
            {`${totalQuestionAnswered} / ${maxAnswerableQuestion}`}
          </SectionInfoItem>
        )}
        {hasOngoingSectional && (
          <SectionInfoItem>{getSectionIcons()}</SectionInfoItem>
        )}
      </SectionInfoRight>
    </Wrapper>
  );
};

export default QuestionsInfo;

QuestionsInfo.propTypes = {
  title: PropTypes.string.isRequired,
  sectionUID: PropTypes.string.isRequired,
  isLocked: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  hasOngoingSectional: PropTypes.bool.isRequired
};
